module.exports = __webpack_public_path__ + "img/0010.6520f851.jpg";